module.exports = __webpack_public_path__ + "static/02-c605ba9d8b09340fb94c38279e2aa357.jpg";